import { noop } from '@src/utils/utils';
import type { FC } from 'react';

export interface TdProps {
    className?: string;
    children?: React.ReactNode;
    onClick?: () => void;
}

const Td: FC<TdProps> = props => {
    const { onClick = noop, children, className = '' } = props;

    return (
        <td onClick={onClick} className={`text-sm pl-4 pr-4 h-12 align-middle whitespace-nowrap ${className}`}>
            {children}
        </td>
    );
};

export default Td;
